import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { getImageResolution } from '../../helpers/Files';

class FileResolution extends PureComponent {
  render() {
    const { file } = this.props;
    const resolution = getImageResolution(file);

    if (!resolution) {
      return null;
    }

    return (
      <span className="file-resolution">
        {resolution}
      </span>
    );
  }
}

FileResolution.propTypes = {
  file: PropTypes.object.isRequired,
};

export default FileResolution;
